<template>
  <svg id="icon-dashboard" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="currentColor" d="M-78.5-12.5h554v512h-554z" />
      <path d="M10 17a7 7 0 1 1 0-14 7 7 0 0 1 0 14zM5.576 6.57A5.572 5.572 0 0 0 4.442 9.3H5.1a.7.7 0 0 1 0 1.4h-.658c.109.879.426 1.718.924 2.45A6.972 6.972 0 0 1 9.3 11.435V7.9a.7.7 0 0 1 1.4 0v3.535a6.972 6.972 0 0 1 3.934 1.715 5.565 5.565 0 0 0 .924-2.45H14.9a.7.7 0 0 1 0-1.4h.658a5.572 5.572 0 0 0-1.134-2.73l-.462.462a.703.703 0 0 1-.994-.994l.469-.462A5.572 5.572 0 0 0 10.7 4.442V5.1a.7.7 0 0 1-1.4 0v-.658a5.532 5.532 0 0 0-2.73 1.134l.462.462a.703.703 0 0 1-.994.994l-.462-.469v.007zm.721 7.63a5.579 5.579 0 0 0 7.406 0 5.579 5.579 0 0 0-7.406 0z" fill="currentColor" fill-rule="nonzero"/>
    </g>
  </svg>
</template>

<script>
export default {};
</script>
